export default __webpack_public_path__ + "static/trees_snow_2-29be03281c1d016849fc7ea638c21718.jpg";